import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, pathAfterAdminLogin } from "@/api";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import { useLang } from "@/i18n";
import LanguageToggle from "@/components/LanguageToggle";

export default function AdminLogin() {
    const nav = useNavigate();
    const { t, dir } = useLang();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("wd-admin-token", data.access_token);
            toast.success(t("adminWelcome"));
            nav(pathAfterAdminLogin(data.role, data.wedding_slugs));
        } catch (err) {
            toast.error(err?.response?.data?.detail || t("adminInvalidCredentials"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-scope min-h-[100dvh] bg-slate-50 flex items-center justify-center p-6" dir={dir}>
            <form onSubmit={submit} className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl shadow-sm p-8 space-y-5" data-testid="admin-login-form">
                <div className="flex justify-end">
                    <LanguageToggle />
                </div>
                <div className="flex items-center gap-2 justify-center text-slate-900">
                    <Heart size={20} className="text-rose-500" fill="currentColor" />
                    <h1 className="text-xl font-semibold tracking-tight">{t("adminLoginTitle")}</h1>
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">{t("email")}</label>
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm outline-none focus:border-slate-400 focus:bg-white"
                        data-testid="admin-email-input"
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">{t("password")}</label>
                    <input
                        type="password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm outline-none focus:border-slate-400 focus:bg-white"
                        data-testid="admin-password-input"
                    />
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full rounded-lg bg-slate-900 text-white py-2.5 text-sm font-medium hover:bg-slate-800 transition disabled:opacity-50"
                    data-testid="admin-login-submit"
                >
                    {loading ? t("adminSigningIn") : t("adminSignIn")}
                </button>
            </form>
        </div>
    );
}
